module.exports = __webpack_public_path__ + "static/img/test_failed.85a7e12.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/test_failed.svg
// module id = x3wy
// module chunks = 4